const initState=[];

const RolesandRightsReducer = (state = initState, action) => {
    switch(action.type) {
        case  'RoleandRightsAction' : return  action.payload;
        default: return state;
    }
}
export default RolesandRightsReducer;